import Landing from "./landing";

const App = () => {
  return <Landing />;
};

export default App;
